import { FC, useEffect } from 'react';

import { readField } from '@eneco/cms-types';
import RichText from '@eneco/components/RichText/RichText';
import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import { Button, Stack } from '@eneco/sparky';
import { StackProps } from '@eneco/sparky/types';
import { signIn } from 'next-auth/react';

import type { FlowNotificationContent } from '../../types/content';

interface Props extends Pick<StackProps, 'alignY'> {
  type?: 'GENERIC' | 'AUTHENTIFICATION';
  /**
   * Either shape: 27 call sites across six flows still pass Sitecore-wrapped
   * fields and migrate one story at a time. See `readField`.
   */
  textualData: {
    notification?: FlowNotificationContent | { value?: FlowNotificationContent };
    buttonLabel?: string | { value?: string };
  };
}

export const FlowError: FC<Props> = ({ textualData, alignY, type = 'GENERIC' }) => {
  const notification = readField<FlowNotificationContent>(textualData?.notification);
  const buttonLabel = readField<string>(textualData?.buttonLabel);

  useEffect(() => {
    if (type === 'AUTHENTIFICATION') signIn('okta');
  }, [type]);

  return (
    <>
      {notification && (
        <TrackedNotificationBox
          label={notification.title}
          title={notification.title}
          isAlert
          text={<RichText html={notification.content} />}
          variant={notification.variant}
        />
      )}

      {buttonLabel && type !== 'AUTHENTIFICATION' && (
        <Stack direction={{ initial: 'column', md: 'row' }} alignY={alignY}>
          <Button type="button" onClick={() => window.location.reload()}>
            {buttonLabel}
          </Button>
        </Stack>
      )}
    </>
  );
};
